import React, {Component, useState, useEffect} from "react";
import {Link, Redirect, Route} from "react-router-dom";

import {Modal, LoginModal} from "../components/common/modal";
import {ModalContext} from '../contexts';
import {Button, Image, RelativeSwitch, SearchField} from "../components/common/common";
import {Checkbox, FormInput, FormText, ValidateForm} from "../components/common/formValidation";
import {
	formatPrice,
	mapObjectToArray,
	objectToArray,
	relativePath,
} from "../lib/tools";
import {reduxWrapper} from "../globalState";
import {BannerHeader, SimpleHeader} from "../components/structure";
import {getImage} from "../lib/api";
import {TileView} from "./tileView";
import { sortProdBySection, BundleListSection } from "../components/views/bundles";
import { toggleState, extractCartData } from '../lib/tools';
import { Footer } from './../components/common/common';

//Icons
import FacebookIcon from "../resources/icons/facebook-white.svg";
import HeartIcon from "../resources/icons/heart.svg";
import HeartWhiteIcon from "../resources/icons/heart-white.svg";
import CloseIcon from "../resources/icons/x-black.svg"
import shareGreyIcon from "../resources/icons/share-grey.svg"
import navArrowIcon from "../resources/icons/downArrow-black.svg"

//Images
import LeafImg from "../resources/images/leaf.png";
import goldImg from "../resources/images/gold.png";
import silverImg from "../resources/images/silver.png";
import bronzeImg from "../resources/images/bronze.png";
import gameBanner from "../resources/images/gameBanner.jpg";
import bgImage from "../resources/images/compBg.jpg";
import stepOneImg from "../resources/images/compPolar.png";
import { isEdge } from "react-device-detect";

// Manage Competition routing
const CompetitionRender = ({awaitEntries, entries}) => {
	const [waiting, setWaiting] = useState(true);

	useEffect(() => {
		awaitEntries(() => setWaiting(false));
	})

	return (
		<RelativeSwitch>
			<Route path="/info" component={CompInfo}/>
			<Route path="/registrer" component={ContestSignup}/>
			<Route path="/byg" component={TileView}/>
			<Route path="/betingelser" component={ContestTerms}/>
			<Route path="fest/:entry" render={({match: {params: {entry}}}) => {
				if (waiting) return null;
				return entries[entry] ?
					<CompetitionPartyView competition entry={entries[entry]}/> :
					<Redirect to={relativePath("..")}/>
			}}/>
			<Route render={() => <CompetitionOverview entries={entries}/>}/>
		</RelativeSwitch>
	)
};
const Competition = reduxWrapper("loadEntries")(CompetitionRender);

const CompInfo = () => {
	return (
		<div className="compInfoWrapper">
			
			<SimpleHeader/>

			<div className="topImage">
				<div className="overlay"/>
				<img src={bgImage} alt="Konkurrence"/>
			</div>

			<div className="compInfoContainer">
				<h2 className="title-s">Byg din drømmefest</h2>
				<h1 className="title-l">Vind et gavekort på 5000,- til din næste fest</h1>
				<img src={stepOneImg} alt="Fest"/>

				<span>Alt du skal gøre:</span>

				<div className="stepsWrapper">
					<div className="stepUnit">
						<p>1. Tilmeld konkurrencen</p>
						<p>Registrer din tilmelding og fortæl hvorfor du skal vinde</p>
					</div>

					<div className="stepUnit">
						<p>2. Lav din drømmefest</p>
						<p>
							Byg din drømmefest, til en værdi af 5000,- ved at finde de 
							produkter du mener der skal til for at få en god fest
						</p>
					</div>

					<div className="stepUnit">
						<p>3. Del din fest</p>
						<p>
							Del din fest, jo flere der kan lide den des bedre.
							Den fest med flest likes inden "XX/XX" Vinder
						</p>
					</div>
				</div>

				<Button to={"/konkurrence/registrer"}>Deltag i konkurrencen</Button>
			
			</div>
		</div>
	)
};

class ContestSignupRender extends Component {
	constructor(props){
		super(props);
		this.slider = React.createRef();
	}

	static contextType = ModalContext;

	state = {
		acceptTerms: false,
		mailExists: false,
		chosenImg: null
	}

	saveInfo = data => {
		sessionStorage.setItem("contest", JSON.stringify({...data, image: this.state.chosenImg}));
		
		if (!data.terms) {
			this.setState(toggleState('acceptTerms'));
			return;
		}

		if(!this.props.userId){
			this.props.register({
				data: {
					email: data.email,
					name: data.name,
					password: data.password,
					image: this.state.chosenImg
				}, 
				success: () => this.props.history.push("byg"), 
				error: () => this.setState(toggleState("mailExists")),
				showError: true
			})
		}else{
			this.props.history.push("byg");
		}
	};

	contestImg = [70414, 70415, 70416, 70417, 70418, 70419, 70420, 
		70421, 70422, 70423, 70424, 70426, 70427, 70428, 70429, 70430, 70431, 70432, 70433, 70434, 70435, 
		70436, 70437, 70438, 70439];

	imgSliderNav = (left) => {
		var slider = this.slider.current;
		var scroll = slider.scrollLeft;
		var slideLength = 170;
		if(isEdge){
			if(left) {
				slider.scrollLeft -= slideLength;
			}else {
				slider.scrollLeft += slideLength;
			}
		}else{
			if(left) {
				slider.scrollTo({
					left: scroll - slideLength,
					behavior: 'smooth'
				})
			}else {
				slider.scrollTo({
					left: scroll + slideLength,
					behavior: 'smooth'
				})
			}
		}
	}

	chooseImg = id => {
		this.setState({
			chosenImg: id
		})
	}

	render() {
		const {userId} = this.props;
		return (
			<Modal className="comSignupModal" onHide={() => this.props.history.push("/konkurrence/info")} bg>
				<h1 className="title-m">Fortæl om din fest</h1>
				<ValidateForm onSubmit={data => this.saveInfo(data)}>
					<div className="comSignupContent">
						<FormInput
							name="title" 
							title="Hvad skal der fejres?" 
							placeholder="fx. Sofies fødselsdag"
							onChan 
							req
						/>
						<div className="formInput">
							<FormText 
								name="description" 
								title="Hvorfor skal du vinde?" 
								maxChar={240}
								text 
								req 
							/>
						</div>
						<div className="comImages">
							<span>Vælg billede</span>
							
							<div className="sliderWrapper">
								<div className="navArrowWrapper left" onClick={() => this.imgSliderNav(true)}>
									<img src={navArrowIcon} alt="Venstre"/>
								</div>
								
								<div id="comImgSlider" ref={this.slider}>
									{this.contestImg.map((x, i) => 
										<img className={this.state.chosenImg === x ? "chosen" : ""} key={i} src={getImage(x)} onClick={() => this.chooseImg(x)} alt={`billede${i}`}/>)
									}
								</div>
								
								<div className="navArrowWrapper right" onClick={() => this.imgSliderNav(false)}>
									<img src={navArrowIcon} alt="højre"/>
								</div>
							</div>
						
						</div>
						{!userId &&
							<div className="registerUserSection">	
								<h1 className="title-s">For at deltage i konkurrencen skal du have en bruger</h1>
								{	this.state.mailExists && 
									<span className="error">Denne email er allerede tilknyttet en bruger</span>
								}
								<FormInput 
									name="email" 
									rules="email" 
									title="Mail" 
									placeholder="Intast e-mail" 
									req
									/>
								<FormInput name="name" title="Navn" req/>
								<FormInput password={true} name="password"/>
								<Button onClick={() => this.context.toggleModal(true, <LoginModal/>)}>Jeg har allerede en bruger</Button>
							</div>
						}
						{this.state.acceptTerms && <span className="error">Venligst accepter vores betingelser!</span>}
						<Checkbox name="terms" title="Accepter vilkår"/>
						<Link to="/konkurrence/betingelser">Læs vilkår og betingelser</Link>
						<Checkbox 
							name="newsletter" 
							title="Tilmeld nyhedsbrev"
						/>
					</div>
					<Button submit>Byg din drømmefest</Button>
				</ValidateForm>
			</Modal>
		)
	}
}
const ContestSignup = reduxWrapper("getApiCall", "getUserId", "getRegister")(ContestSignupRender);

export class ContestRegisterModal extends Component {
	static contextType = ModalContext;
	party = JSON.parse(sessionStorage.getItem("contest"));

	onCopy = () => {
		document.getElementById("partyLink").select();
		document.execCommand('copy');
	};

	onHide = () => {
		this.context.toggleModal(false);
	};

	render(){
		const {partyId} = this.props;
		return(
			<Modal className="comRegisterModal" onHide={this.onHide} bg>
				<h1 className="title-m">Du er nu med i konkurrencen!</h1>
				<p>
					Øg din chance for at vinde ved at dele din fest med dine venner.
				</p>
				<div className="sharePartyInfo">
					<span className="partyName">{this.party.title}</span>
					<span className="partyDesc">{this.party.description}</span>
				</div>
				<div className="shareFacebook ga-sharePartyFb" 
					onClick={() => window.FB.ui({
						method: "share",
						href: `https://www.festen.dk/konkurrence/${partyId}`,
						hashtag: "#VindDinFest",
						quote: this.party.description
					}, response => {
						console.log(response);
						//this.history.push(`/fest/${id}`)
					})}
				>
					<img src={FacebookIcon} alt="Del på Facebook"/>
					Del på Facebook
				</div>
				<div className="shareLink">
					<input type="text" id="partyLink" value={"https://festen.dk/konkurrence/" + partyId} readOnly/>
					<Button onClick={() => this.onCopy()}>Kopier link</Button>
				</div>
				<Button onClick={() => this.onHide()} to={`fest/${partyId}`}>Afslut</Button>
			</Modal>
		)
	}
}

// Shows the top 3 parties and list all registered parties
class CompetitionOverviewRender extends Component {
	
	state = {
		search: ""
	};
	
	render() {
		const {entries, userInfo} = this.props;
		const sortedEntries = objectToArray(entries).sort((a, b) => b.votes - a.votes);
		const search = this.state.search.toLowerCase();
		const filteredEntries = search ? sortedEntries.slice(2).filter(x => x.title.toLowerCase().includes(search) || x.description.toLowerCase().includes(search)) : sortedEntries.slice(2);
		
		return (
			<div className="compOverviewWrapper">
				<BannerHeader bgImage={gameBanner}>
					<h1>Vind en fest</h1>
					<p>
						Deltag i konkurrencen om at vinde din skræddersyede fest.
						Alt du skal gøre er at sammensætte din fest og promovere den.
					</p>
				</BannerHeader>
				<div className="compOverviewContent maxWidth">
					<div className="compTopThree">

						{ !userInfo.inCompetition &&
							<Link to={relativePath("/info")} className="compTopTag">Deltag i konkurrencen</Link>
						}

						<div className="compTitleWrapper">
							<div className="shadowContainer">
								<div className="compTitle">
									<img src={LeafImg} alt={"Blad"}/>
									<span>Top 3</span>
									<img src={LeafImg} alt={"Blad"}/>
								</div>
								<SearchField onSearch={search => this.setState({search})}/>
							</div>
						</div>
						<div className="bundlesListContainer">

							{/* First Place */}
							{sortedEntries.length > 0 && <div className="topThreeParty">
								<img src={goldImg} alt="Førsteplads"/>
								<CompetitionPartyPreview competition entry={sortedEntries[0]}/>
							</div>}

							{/* Second Place */}
							{sortedEntries.length > 1 && <div className="topThreeParty">
								<img src={silverImg} alt="Andenplads"/>
								<CompetitionPartyPreview competition entry={sortedEntries[1]}/>
							</div>}

							{/* Third Place */}
							{sortedEntries.length > 2 && <div className="topThreeParty">
								<img src={bronzeImg} alt="Tredjeplads"/>
								<CompetitionPartyPreview entry={sortedEntries[2]}/>
							</div>}

						</div>
					</div>
					<div className="compPartyList">
						<div className="shadowContainer bundlesListContainer">
							{filteredEntries.map(x =>
								<CompetitionPartyPreview entry={x} key={x.id}/>
							)}
						</div>
					</div>
				</div>
			</div>
		)
	}
}
const CompetitionOverview = reduxWrapper("loadUserInfo")(CompetitionOverviewRender);

// A preview view of the registered party
class CompetitionPartyPreviewRender extends Component {
	render() {
		const {entry: {title, description, id, votes, total, guests, occasion, voted, image}, occasions, entryVote, entryDownvote} = this.props;
		return (
			<div className="bundlePreview">
				<Link to={relativePath(`fest/${id}`)}>
					<div className="bundleImages" style={{backgroundImage: `url(${getImage(image)})`}}>
						<div></div>
					</div>
					<div className="bundleText">
						<span className="bundleCategory">{occasions[occasion] && occasions[occasion].name}</span>
						<h1>{title}</h1>
						<div className="bundleDescWrapper">
							<span className="line"/>
							<span className="bundleDesc">{description}</span>
						</div>
					</div>
				</Link>
				<div className="actionWrapper" onClick={e => e.stopPropagation()}>
					<CompetitionActionBtn 
						className="share ga-sharePartyFb" 
						icon={shareGreyIcon} 
						text="Del" 
						onClick={() => window.FB.ui({
							method: "share",
							href: `https://www.festen.dk/konkurrence/${id}`,
							hashtag: "#VindDinFest"
						}, reponse => {})}
					/>
					<CompetitionActionBtn className={voted ? "liked" : "like"} icon={voted ? HeartWhiteIcon : HeartIcon} text={votes} onClick={() => voted ? entryDownvote({id}) : entryVote({id})}/>
				</div>
			</div>
		)
	}
}
const CompetitionPartyPreview = reduxWrapper("getEntryVote", "getEntryDownvote", "loadOccasions")(CompetitionPartyPreviewRender);

const CompetitionActionBtn = ({icon, text, className, onClick}) => (
	<div className={["bundleActionBtn", className].join(" ")} onClick={onClick}>
		<img src={icon} alt={className}/>
		{text}
	</div>
);


// Single competition party view
class CompetitionPartyViewRender extends Component {
	state = {
		products: [],
		sortedProducts: {}
	};

	componentWillMount() {
		this.props.apiCall("GET", `/competition/entry/${this.props.entry.id}/products`, products => {
			this.props.cacheProduct({
				products: products.map(x => x.productId), 
				full: true
			}).then(() => {
				let extract = [];
				let cartData = extractCartData(this.props.cart, this.props.products);
				console.log(cartData);
				for (let i = 0; i < cartData.products.length; i++) {
					let id = cartData.products[i].productId;
					let qty = cartData.products[i].qty;
					extract.push({...this.props.products[id], qtyOrdered: qty });
				}
				console.log(extract);
				this.props.awaitSections(sections => {
					let sorted = sortProdBySection(extract, sections);
					this.setState({products: sorted});
				})
			})
		})
	}

	render() {
		const {
			entry: {title, description, id, votes, voted, images, total, image}, 
			entryVote, 
			entryDownvote, 
		} = this.props;
		
		return (
			<div className="singleBundlePageWrapper">
				
				<div className="singleBundlePageContainer maxWidth">
					<Link className="close" to={relativePath("./")}>
						<img src={CloseIcon} alt="Tilbage"/>
					</Link>
					<div className="imagesWrapper" style={{backgroundImage: `url(${getImage(image)})`}}/>
					<div className="infoWrapper">
						<div className="infoContent">
							<h1 className="title-l">{title}</h1>
							<div className={["bundleDescWrapper", this.state.descExtended ? "extended" : ""].join(" ")}>
								<div className="bundleDesc">{description}</div>
								<div className="showMoreWrapper">
									<div className="showMoreBtn" onClick={() => this.setState(toggleState("descExtended"))}>VIS MERE</div>
								</div>
							</div>
							
							<div className="bundleProductsWrapper">
								<h2>Festens indhold</h2>
								{
									mapObjectToArray(this.state.products, (x, i) =>
										this.state.products["Maden"].length > 0 ?
											<BundleListSection key={i} title={i} sections={x} open={i === "Maden"} contest/> :
											<BundleListSection key={i} title={i} sections={x} open={i === "Drikkevarer"} contest/>
									)
								}
								<span>I alt: {formatPrice(total)} kr.</span>
							</div>
						</div>

						<div className="actionWrapper">
							<CompetitionActionBtn 
								className="share ga-sharePartyFb" 
								icon={shareGreyIcon} 
								text="Del" 
								onClick={() => window.FB.ui({
									method: "share",
									href: `https://www.festen.dk/konkurrence/${id}`,
									hashtag: "#VindDinFest"
								}, reponse => {})}
							/>
							<CompetitionActionBtn className={voted ? "liked" : "like"} icon={voted ? HeartWhiteIcon : HeartIcon} text={votes} onClick={() => voted ? entryDownvote({id}) : entryVote({id})}/>
						</div>
					</div>
				</div>
			
			</div>
		)
	}
}
const CompetitionPartyView = reduxWrapper(
	"getApiCall", 
	"loadSections", 
	"getEntryVote", 
	"getEntryDownvote", 
	"loadOccasions", 
	"getCacheProduct", 
	"loadProducts",
	"loadCart"
	)(CompetitionPartyViewRender);

const ContestTerms = () => {
	return (
		<article className="festenInfoPage">
			<BannerHeader bgImage={bgImage}>
				<h1>Konkurrence</h1>
			</BannerHeader>
			<div className="maxWidth">
				<section className="infoSection">
					<h1>Konkurrencebetingelser</h1>
					<p>
						Regler og betingelser for deltagelse i konkurrencen om Danmarks bedste festplanlægger.
					</p>
					<p>
						Konkurrencen udbydes af Festen.dk ApS CVR. 34725195.
					</p>
					<p>
						Henvendelser vedrørende konkurrencen kan rettes til kontakt@festen.dk
					</p>
				</section>
				
				<section className="infoSection">
					<h1>Sådan deltager du</h1>
					<p>
						Konkurrencen er ikke købsbetinget og løber fra X – X 2019. Kun personer over 18 år ogsom er bosat i Danmark kan deltage i konkurrencen. 
						Gå ind på Festen.dk og sammensæt din drømmefest, det gør du ved at finde de produkter som du mener man skal bruge for at få en rigtig god fest, 
						du tilføjer dem til kurven og når du har fundet alt hvad du skal bruge trykker du på tilmeld konkurrencen.
					</p>
					<p>
						Alle de fester der bliver lavet vil blive samlet <Link to="/konkurrence" style={{color: "red"}}>her</Link> hvor man kan give de fester man synes om et Like.
					</p>
				</section>

				<section className="infoSection">
					<h1>Sådan vinder du</h1>
					<p>Den X – X 2019 bliver den festplanlægger der har fået flest likes, belønnet med et gavekort på 5000,- til Festen.dk</p>
					<p>Præmien kan ikke ombyttes til kontanter eller overdrages til andre.</p>
				</section>

				<section className="infoSection">
					<h1>Hvad skal du ellers vide?</h1>
					<p>
						Festen.dk er uden ansvar for evt. Forkert udleverende præmier som følge af snyd. Festen.dk forbeholder sig ret til løbende at revidere regler og kan ændre reglerne, såfremt det skønnes nødvendigt. Festen.dk er ikke ansvarlig for at gøre opmærksom på eventuelle fejl og mangler.
					</p>
					<p>
						Festen.dk afholder alle præmieafgifter. Skulle en person, som følge af præmien pådrage sig et skattemæssigt ansvar eller et ansvar i forbindelse med sociale ydelser, fraskriver Festen.dk sig ethvert ansvar i den forbindelse.
					</p>
					<p>
						Festen.dk forbeholder sig retten til at blokkere/slette indhold og billeder, der krænker tredjemandsrettigheder, samt stooppe konkurrencen uden varsel. Ved mistanke om snyd forbeholder Festen.dk sig retten at ekskludere brugere uden varsel.
					</p>
					<p>
						Konkurrencen udbydes af Festen.dk ApS, Thujavej 13 5250 Odense SV
					</p>
				</section>

				<section className="infoSection">
					<h1>Generelle konkurrencebetingelser</h1>
					<p>
						Følgende er gældende, nå du deltager i en af Festen.dks konkurrencer – medmindre andet er angivet. Regler gælder både for konkurrencer på Festen.dk og på sociale medier.
					</p>
					<h2>Deltagelse</h2>
					<p>
						Det er kun tilladt at deltage én gang pr. Deltager. Deltagelse modtaget efter sidste frist vil ikke blive medtaget i vurderingen.Man skal være fyldt 18 år for at deltage i konkurrencer afholdt af Festen.dk. Hvis der erenkeltstående tilfælde af andre regler, vil dette blive oplyst i den enkelte konkurrencebeskrivelse. Hvis ikke der er gældende udtagelser, forbeholder Festen.dk sig retten til at kontrollere alderen på vinderen og frasortere deltagere under 18 år. Ansatte i Festen.dk må ikke deltage.
					</p>
					<h2>Præmier</h2>
					<p>
						Præmier kan ikke omsættes til kontanter eller udløses af andre end den der har vundet.
					</p>
					<h2>Vindere</h2>
					<p>
						Konkurrencevindere kontaktes som udgangspunkt direkte. Festen.dk forbeholder sig retten til at offentliggøre det fulde navn på vindere af en konkurrence på Festen.dk såvel som de sociale medier Festen.dk anvender. Hvis vi ikke kan få fat i vinderen, forbeholder vi os retten til at udtrække en ny vinder.
					</p>
				</section>

			</div>
			<Footer/>
		</article>
	)
};

export default Competition;


// WEBPACK FOOTER //
// ./src/contest/competition.js